module.exports = new __parcel__URL__("typescript.9075684b.svg").toString();